import { render, staticRenderFns } from "./AnimatedBurger.vue?vue&type=template&id=12fb8103&"
import script from "./AnimatedBurger.vue?vue&type=script&lang=js&"
export * from "./AnimatedBurger.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedBurger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports